import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { MyProjectFragment } from '@src/generated/graphql';

const Properties: React.FC<Pick<MyProjectFragment, 'properties'>> = ({
  properties,
}) => {
  if (!properties) return null;

  return (
    <Flex direction="column">
      {properties?.map((property) => (
        <Flex key={property?.key}>
          <Text color="primary" fontFamily="montserrat" fontWeight="bold">
            {property?.key}: {property?.value}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
};

export default Properties;
